<script>
import { mapActions } from 'vuex';
import request from '@/services/request'

export default {
    name: 'ModalFilesContractsComponent',
    props: {
        prop_edit: {
            default: true,
        },
    },
    data() {
        return {
            form: {
                contract_id: '',
            },
            send: false,
            load: false,
            errors: {},
            file: [],
            drive: '',            
        };
    },
    methods: {
        async delImgUpload(id) {
            let tit = 'Eliminar archivo';
            let txt = 'Seguro que quiere eliminar el archivo';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        let _endpoint = '/contract_files/' + id;
                        let { data } = await request.destroy(_endpoint)
                        if (data) {
                            this.successNotification(data.message);
                            this.list();
                            Event.$emit('event-load-contracts');
                        }
                    } catch (error) {
                        this.errors = {};
                        if (error.response) {
                            this.errors = await this.errorNotification(error);
                        }
                    }
                }
            });

        },
        async list() {
            this.load = true;
            let _endpoint = '/contract_files?contract_id=' + this.form.contract_id;
            try {
                let { data } = await request.get(_endpoint)
                if (data) {
                    this.file = data;
                    this.load = false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },
        async uploadFiles(event) {
            this.send = true;
            let formData = new FormData();
            formData.append('contract_id', this.form.contract_id);
            formData.append('file', event.target.files[0]);

            let _endpoint = '/contract_files';
            try {
                let { data } = await request.postMedia(_endpoint, formData)
                if (data) {
                    this.successNotification(data.message);
                    this.list();
                    this.send = false;
                    Event.$emit('event-load-contracts');
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                    this.send = false;
                }
            }

        },
        close() {
            this.form.contract_id = '';
            this.file = [];
            this.send = false;
            this.errors = {};
            this.$modal.hide('addFilesContracts');

        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-addFilesContracts", (contract) => {
            this.$modal.show('addFilesContracts');
            this.form.contract_id = contract.id;
            this.drive = contract.drive;
            this.list();
        });
    },
};
</script>

<template>
    <modal name="addFilesContracts" :width="'80%'" :maxHeight="300" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="close()">
            <i class="fa-solid fa-xmark"></i>
        </button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Evidencia adjunta del contrato</h5>
        </div>
        <div class="modal-body">
            <div class="col-12 text-center" v-if="load || send">
                <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                <h5>Cargando</h5>
            </div>
            <div class="col-12 text-center" v-else>
                <h3>Evidencia adjunta.</h3>
                <p>Maximo 5 archivos.</p>
                <p v-if="drive">Link recursos:<br>
                    <a :href="`${drive}`" target="_blank">{{ drive }}</a>
                </p> 
                <div class="row mt-5 mb-5">
                    <div class="col-12" v-if="(file.length) == 0">
                        <i class="fa-solid fa-file fa-4x"></i>
                        <p>Sin archivos adjuntos</p>
                    </div>
                    <div class="col-md-4 col-12 p-2" v-for="(fAdd, index_fAdd) in file" :key="index_fAdd"
                        v-show="file.length > 0">
                        <div class="card shadow">
                            <button v-if="prop_edit" class="btn btn-sm btn-danger del" type="button"
                                @click="delImgUpload(fAdd.id)">
                                <i class="fa fa-trash"></i></button>
                            <div class="card-body text-center">
                                <a :href="`${globalUrlFiles}${fAdd.file}`" target="_blank">
                                    <i class="fa fa-file fa-4x"></i>
                                    <p>{{ fAdd.file_name }}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="image-upload btn btn-outline-secondary btn-lg" v-if="(file.length) <= 4 && (prop_edit)">
                    <label for="file-input" class="m-0">
                        <h4 class="m-0"> <i class="fa-solid fa-file fa-1x mr-2"></i>
                            Subir
                            Archivo</h4>
                    </label>
                    <input id="file-input" type="file" @change="uploadFiles" />
                </div>
                <div v-if="errors && errors.file" class="text-danger mt-2">{{ errors.file[0] }}
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="close">Cerrar</button>
        </div>
    </modal>
</template>